import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-100 h-100 d-flex flex-column align-items-center justify-content-center"
}
const _hoisted_2 = {
  key: 0,
  style: {"margin-bottom":"0.25rem"}
}
const _hoisted_3 = {
  style: {"margin-bottom":"1rem","font-size":"1.125rem"},
  class: "text-black text-center"
}
const _hoisted_4 = {
  key: 1,
  style: {"width":"100%","max-width":"9rem","margin":"0 auto"}
}
const _hoisted_5 = { class: "flex-center" }

import { type Component, computed } from "vue";

import { Button } from "@/components/global";
import { ButtonRounded, ButtonSize, ButtonVariant } from "./Button.vue";

interface Props {
  data?: unknown[] | null;
  loading?: boolean;
  message?: string;
  buttonText?: string;
  buttonIcon?: Component | string | null;
  buttonVariant?: ButtonVariant;
  buttonRounded?: ButtonRounded;
  buttonSize?: ButtonSize;
  buttonTestId?: string;
  iconComponent?: Component | string | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EmptyStateAction',
  props: {
    data: {},
    loading: { type: Boolean, default: false },
    message: { default: "No data available" },
    buttonText: {},
    buttonIcon: {},
    buttonVariant: { default: "default" },
    buttonRounded: { default: "lg" },
    buttonSize: { default: "sm" },
    buttonTestId: { default: "empty-state-btn" },
    iconComponent: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const show = computed(
  () =>
    (!props.data && !props.loading) ||
    ((props.data as unknown[] | null)?.length === 0 && !props.loading)
);

const onClick = () => {
  emit("click");
};

return (_ctx: any,_cache: any) => {
  return (show.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.iconComponent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(__props.iconComponent)))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_3, _toDisplayString(__props.message), 1),
        (__props.buttonText)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(Button), {
                variant: __props.buttonVariant,
                rounded: __props.buttonRounded,
                size: __props.buttonSize,
                testId: __props.buttonTestId,
                onClick: onClick
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_5, [
                    (__props.buttonIcon)
                      ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.buttonIcon), {
                          key: 0,
                          width: "10",
                          height: "10",
                          style: {"margin-right":"0.25rem"}
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(__props.buttonText), 1)
                  ])
                ]),
                _: 1
              }, 8, ["variant", "rounded", "size", "testId"])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})